/**
 * Shared "state" tone used by metric_grid, bar_chart, and stacked_bar_chart
 * blocks (mirrors the `state` enum on those blocks in
 * `@almanac/contracts` digest.ts).
 *
 * All classes resolve to the shadcn/ui-style semantic tokens defined in the
 * consuming app's theme (`--success` / `--warning` / `--danger` / `--info` /
 * `--muted*`), so tones flip between light and dark automatically — no
 * `dark:` variants here.
 */
export const STATE_TONES = ['ok', 'warn', 'alert', 'info', 'neutral'];
export const STATE_TEXT_CLASS = {
    ok: 'text-success',
    warn: 'text-warning',
    alert: 'text-danger',
    info: 'text-info',
    neutral: 'text-muted-foreground',
};
export const STATE_BG_CLASS = {
    ok: 'bg-success',
    warn: 'bg-warning',
    alert: 'bg-danger',
    info: 'bg-info',
    neutral: 'bg-muted-foreground',
};
export const STATE_BADGE_CLASS = {
    ok: 'bg-success/10 text-success',
    warn: 'bg-warning/10 text-warning',
    alert: 'bg-danger/10 text-danger',
    info: 'bg-info/10 text-info',
    neutral: 'bg-muted text-muted-foreground',
};
